import React from 'react';
import { Col, Container, Row } from "reactstrap";
import { withRouter } from "react-router-dom";

const queryString = require('query-string');
const parsed = queryString.parse(window.location.search);
const lang = (parsed.lang ? parsed.lang.toLowerCase() : null) || 'en';

const content = {
  en: <>
  <h1>How to Screen Record</h1>
          <p>To screen record and complete this task, you will need to install the free MSR-approved app <b>AZ
            Screen Recorder</b>.</p>

          <div className="app-store-download-container">
            <div className="download-icon">
              <a
                target="_blank"
                href='https://play.google.com/store/apps/details?id=com.hecorat.screenrecorder.free&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'
              >
                <img
                  className="google-play-icon"
                  alt='Get it on Google Play'
                  src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'/>
              </a>
            </div>
              <ul className="download-attributes">
                <li>4.5 <span className="star">★</span></li>
                <li>1,418,215 total installs</li>
              </ul>
          </div>

          <div className="steps">
            <div className="step">
              <div className="step-number">1</div>
              <div className="step-description">
                <p>Open AZ Screen Recorder and follow the required steps to set it up.</p>
              </div>
            </div>
            <div className="step">
              <div className="step-number">2</div>
              <div className="step-description">
                <p>When you are ready to start recording, tap the <b>red icon</b>
                  <img
                    className="word-sized-icon"
                    alt="AZ Screen Recorder icon"
                    src="https://d3s00xghdjywqy.cloudfront.net/c2/retro/android-screen-recording/app-icon@3x.png"
                  />
                  on your home screen to open the menu.</p>
              </div>
            </div>
            <div className="step">
              <div className="step-number">3</div>
              <div className="step-description">
                <p>With the menu open, tap the top button with the
                  <img
                    className="word-sized-icon"
                    alt="Video icon"
                    src="https://d3s00xghdjywqy.cloudfront.net/c2/retro/android-screen-recording/step-3-video-icon@3x.png"
                  />
                  <b>video icon</b>.
                </p>
              </div>
            </div>
            <div className="step">
              <div className="step-number">4</div>
              <div className="step-description">
                <p>A three second <b>countdown</b> will count you in and a <b>timer</b> will appear on screen to remind
                  you you’re recording.</p>
              </div>
            </div>
            <div className="step">
              <div className="step-number">5</div>
              <div className="step-description">
                <p>When have finished your task, tap the timer to <b>open the menu</b> and select the <b>stop button</b>.</p>
              </div>
            </div>
            <div className="step">
              <div className="step-number">6</div>
              <div className="step-description">
                <p>A <b>pop up dialog</b> will appear to inform you that the video has been <b>successfully saved</b>.</p>
              </div>
            </div>
          </div>
  </>,

  es: <>
    <h1>Cómo realizar una grabación de pantalla</h1>
    <p>Para grabar la pantalla y completar esta tarea, deberá instalar la aplicación gratuita aprobada por MSR <b>AZ Grabador de pantalla</b>.</p>
    <div className="app-store-download-container">
            <div className="download-icon">
              <a
                target="_blank"
                href='https://play.google.com/store/apps/details?id=com.hecorat.screenrecorder.free&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'
              >
                <img
                  className="google-play-icon"
                  alt='Get it on Google Play'
                  src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'/>
              </a>
            </div>
              <ul className="download-attributes">
                <li>4.5 <span className="star">★</span></li>
                <li>1.418.215 instalaciones totales</li>
              </ul>
          </div>

          <div className="steps">
            <div className="step">
              <div className="step-number">1</div>
              <div className="step-description">
                <p>Abre AZ Screen Recorder y sigue los pasos requeridos para configurarlo.</p>
              </div>
            </div>
            <div className="step">
              <div className="step-number">2</div>
              <div className="step-description">
              <p>Cuando estés listo para comenzar a grabar, toca el <b>icono rojo</b>
                   <img
                     className="word-sized-icon"
                     alt="Icono de Grabador de pantalla AZ"
                     src="https://d3s00xghdjywqy.cloudfront.net/c2/retro/android-screen-recording/app-icon@3x.png"
                   />
                   en la pantalla de inicio para abrir el menú.</p>
              </div>
            </div>
            <div className="step">
              <div className="step-number">3</div>
              <div className="step-description">
              <p>Con el menú abierto, toque el botón superior con el
                   <img
                     className="word-sized-icon"
                     alt="Ícono de vídeo"
                     src="https://d3s00xghdjywqy.cloudfront.net/c2/retro/android-screen-recording/step-3-video-icon@3x.png"
                   />
                   <b>icono de vídeo</b>.
                 </p>
              </div>
            </div>
            <div className="step">
              <div className="step-number">4</div>
              <div className="step-description">
              <p>Una <b>cuenta atrás</b> de tres segundos contará contigo y aparecerá un <b>temporizador</b> en la pantalla para recordarte estás grabando.</p>
              </div>
            </div>
            <div className="step">
              <div className="step-number">5</div>
              <div className="step-description">
                <p>Cuando hayas terminado tu tarea, toca el cronómetro para <b>abrir el menú</b> y selecciona el <b>botón de detener</b>.</p>
              </div>
            </div>
            <div className="step">
              <div className="step-number">6</div>
              <div className="step-description">
                <p>Aparecerá un <b>cuadro de diálogo emergente</b> para informarle que el vídeo se ha <b>guardado correctamente</b>.</p>
              </div>
            </div>
          </div>
  </>,
  pt: <>
<h1>Como gravar a tela</h1>
           <p>Para gravar a tela e concluir esta tarefa, você precisará instalar o aplicativo gratuito aprovado pelo MSR <b>AZ
             Gravador de tela</b>.</p>

          <div className="app-store-download-container">
            <div className="download-icon">
              <a
                target="_blank"
                href='https://play.google.com/store/apps/details?id=com.hecorat.screenrecorder.free&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'
              >
                <img
                  className="google-play-icon"
                  alt='Get it on Google Play'
                  src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'/>
              </a>
            </div>
              <ul className="download-attributes">
                <li>4.5 <span className="star">★</span></li>
                <li>1.418.215 instalações no total</li>
              </ul>
          </div>

          <div className="steps">
            <div className="step">
              <div className="step-number">1</div>
              <div className="step-description">
              <p>Abra o AZ Screen Recorder e siga as etapas necessárias para configurá-lo.</p>
              </div>
            </div>
            <div className="step">
              <div className="step-number">2</div>
              <div className="step-description">
              <p>Quando estiver pronto para começar a gravar, toque no <b>ícone vermelho</b>
                   <img
                     className="word-sized-icon"
                     alt="ícone do gravador de tela AZ"
                     src="https://d3s00xghdjywqy.cloudfront.net/c2/retro/android-screen-recording/app-icon@3x.png"
                   />
                   na tela inicial para abrir o menu.</p>
              </div>
            </div>
            <div className="step">
              <div className="step-number">3</div>
              <div className="step-description">
              <p>Com o menu aberto, toque no botão superior com o
                   <img
                     className="word-sized-icon"
                     alt="Ícone de vídeo"
                     src="https://d3s00xghdjywqy.cloudfront.net/c2/retro/android-screen-recording/step-3-video-icon@3x.png"
                   />
                   <b>ícone de vídeo</b>.
                 </p>
              </div>
            </div>
            <div className="step">
              <div className="step-number">4</div>
              <div className="step-description">
              <p>Uma <b>contagem regressiva</b> de três segundos contará você e um <b>temporizador</b> aparecerá na tela para lembrar você está gravando.</p>
              </div>
            </div>
            <div className="step">
              <div className="step-number">5</div>
              <div className="step-description">
              <p>Quando terminar sua tarefa, toque no cronômetro para <b>abrir o menu</b> e selecione o <b>botão parar</b>.</p>
              </div>
            </div>
            <div className="step">
              <div className="step-number">6</div>
              <div className="step-description">
              <p>Uma <b>caixa de diálogo pop-up</b> aparecerá para informar que o vídeo foi <b>salvo com sucesso</b>.</p>
              </div>
            </div>
          </div>
  </>,
  id: <>
  <h1>Cara Menyaring Rekaman</h1>
           <p>Untuk menyaring rekaman dan menyelesaikan tugas ini, Anda perlu menginstal aplikasi gratis yang disetujui MSR <b>AZ
             Perekam Layar</b>.</p>

          <div className="app-store-download-container">
            <div className="download-icon">
              <a
                target="_blank"
                href='https://play.google.com/store/apps/details?id=com.hecorat.screenrecorder.free&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'
              >
                <img
                  className="google-play-icon"
                  alt='Get it on Google Play'
                  src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'/>
              </a>
            </div>
              <ul className="download-attributes">
                <li>4.5 <span className="star">★</span></li>
                <li>1.418.215 total pemasangan</li>
              </ul>
          </div>

          <div className="steps">
            <div className="step">
              <div className="step-number">1</div>
              <div className="step-description">
              <p>Buka AZ Screen Recorder dan ikuti langkah-langkah yang diperlukan untuk menyiapkannya.</p>
              </div>
            </div>
            <div className="step">
              <div className="step-number">2</div>
              <div className="step-description">
              <p>Saat Anda siap untuk mulai merekam, ketuk <b>ikon merah</b>
                   <img
                     className="word-sized-icon"
                     alt="Ikon Perekam Layar AZ"
                     src="https://d3s00xghdjywqy.cloudfront.net/c2/retro/android-screen-recording/app-icon@3x.png"
                   />
                   di layar utama Anda untuk membuka menu.</p>
              </div>
            </div>
            <div className="step">
              <div className="step-number">3</div>
              <div className="step-description">
              <p>Saat menu terbuka, ketuk tombol atas dengan
                   <img
                     className="word-sized-icon"
                     alt="Ikon video"
                     src="https://d3s00xghdjywqy.cloudfront.net/c2/retro/android-screen-recording/step-3-video-icon@3x.png"
                   />
                   <b>ikon video</b>.
                 </p>
              </div>
            </div>
            <div className="step">
              <div className="step-number">4</div>
              <div className="step-description">
              <p><b>hitung mundur</b> tiga detik akan menghitung jumlah Anda dan <b>pengatur waktu</b> akan muncul di layar untuk mengingatkan
                   kamu yang kamu rekam.</p>
              </div>
            </div>
            <div className="step">
              <div className="step-number">5</div>
              <div className="step-description">
              <p>Setelah tugas Anda selesai, ketuk pengatur waktu untuk <b>membuka menu</b> dan pilih <b>tombol berhenti</b>.</p>
              </div>
            </div>
            <div className="step">
              <div className="step-number">6</div>
              <div className="step-description">
              <p><b>Dialog pop up</b> akan muncul untuk memberitahukan Anda bahwa video telah <b>berhasil disimpan</b>.</p>
              </div>
            </div>
          </div>
  </>,
}

function ScreenRecordingInstructionsAndroid({history}) {



  return (
    <Container fluid="sm" className="retro-instructions screen-recording-instructions">
      <Row>
        <Col>

          <div className="data-type-logo square-icon">
            <img
              alt="Screen Recording"
              src="https://d3s00xghdjywqy.cloudfront.net/c2/retro/android-screen-recording/az-screen-recorder-icon@3x.png"
            />
          </div>

          {content[lang] ?? content.en}

          <div className="action-button">
            <span className="btn btn-primary" onClick={() => history.goBack()}>Done</span>
          </div>

        </Col>
      </Row>
    </Container>
  );
}

export default withRouter(ScreenRecordingInstructionsAndroid);
